
export class Gender {

    genderId: number;
    name    : string;

}
